<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-pc-detail-card">
    <v-row class="com-pc-card-header">
      <div class="com-pc-card-title">{{ text.obsInfo }} {{ appTime }}</div>
      <v-tooltip bottom max-width="450px">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2"
            >help_outline</v-icon
          >
        </template>
        <span>
          <span>
            {{ legendStr.tmStg.tmStgMsg1 }}
            <br />
            {{ legendStr.tmStg.tmStgMsg2 }}
            <br />
          </span>
          <span class="text-flood-occurrence legend-stg-span mb-1">
            {{ legendStr.tmStg.occurrence }}
          </span>
          <br />
          <span class="text-flood-danger legend-stg-span mb-1">
            {{ legendStr.tmStg.danger }}</span
          >
          <br />
          <span class="text-flood-refuge legend-stg-span mb-1">
            {{ legendStr.tmStg.refuge }}
          </span>
          <br />
          <span class="text-flood-warn legend-stg-span mb-1">
            {{ legendStr.tmStg.warn }}
          </span>
        </span>
      </v-tooltip>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            dark
            small
            class="pl-2 refresh-icon-size"
            @click="renew"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>
        <span>{{ this.tooltipStr.refresh }}</span>
      </v-tooltip>
      <v-btn
        class="com-pc-card-button"
        @click="openMap()"
        max-height="20"
      >
        <v-icon>link</v-icon> {{ text.checkMap }}
      </v-btn>
    </v-row>
    <v-expansion-panels accordion class="tm-pc-detail-info-panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-1 pr-4">
          <v-row no-gutters align="center" justify="start">
            <v-col md="auto" class="ma-2">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <img
                    src="/kawabou/img/obs_icons/obs_water.svg"
                    class="tm-pc-detail-icon"
                    v-on="on"
                  />
                </template>
                <span>{{ text.obsType }}</span>
              </v-tooltip>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ tmStageList.tmStgDetailInfo.obsKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ tmStageList.tmStgDetailInfo.obsNm }}
              </div>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ tmStageList.tmStgDetailInfo.rsysKana }}{{ text.rsysKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ tmStageList.tmStgDetailInfo.rsysNm }}{{ text.rsys }}
              </div>
            </v-col>
            <v-col md="auto" class="ma-2">
              <div class="tm-pc-detail-frame-info-rvrnm-kana">
                {{ tmStageList.tmStgDetailInfo.rvrKana }}
              </div>
              <div class="tm-pc-detail-frame-info-rvrnm">
                {{ tmStageList.tmStgDetailInfo.rvrNm }}
              </div>
            </v-col>
            <!--上流側側での水位情報を基にして表示するベルアイコン表示しない -->
            <!-- <div
              v-if="tmStageList.warningFlg"
              class="tm-pc-detail-frame-warning"
            >
              <v-icon class="tm-pc-detail-frame-warning-icon"
                >notifications_active</v-icon
              >
              {{ stgMsg.upObsWarning1 }}{{ stgMsg.upObsWarning2 }}
            </div> -->
            <div class="tm-pc-detail-frame-space"></div>

            <v-col class="pl-2">
              <!-- 観測値 -->
              <div class="tm-pc-detail-info-latest-value pb-1">
                <span>{{ text.obs_title }}</span>
                <span class="pl-2">{{ tmStageList.curt.obsTime }}</span>
              </div>
              <div class="tm-pc-detail-border-line pt-1">
                <span
                  v-for="(item, index) in tmStageList.curt.obs"
                  :key="index"
                >
                  <span
                    v-if="index === 0 && stgMode === '1' && dspFlg === 2"
                    class="tm-pc-detail-info-curt-title"
                  >
                    {{ item.title[0] }}:
                  </span>
                  <span
                    v-else-if="index === 0"
                    class="tm-pc-detail-info-curt-title"
                  >
                    {{ item.title[stgMode] }}:
                  </span>
                  <span v-else class="tm-pc-detail-info-curt-title">
                    {{ item.title }}:
                  </span>

                  <span
                    v-if="index === 0 && stgMode === '1' && dspFlg === 2"
                    class="tm-pc-detail-info-curt-value"
                  >
                    {{ item.value[0] }}
                  </span>
                  <span
                    v-else-if="index === 0"
                    class="tm-pc-detail-info-curt-value"
                  >
                    {{ item.value[stgMode] }}
                  </span>
                  <span v-else class="tm-pc-detail-info-curt-value">
                    {{ item.value }}
                  </span>

                  <span class="tm-pc-detail-info-curt-unit" v-html="item.unit">
                  </span>
                  <span
                    v-if="
                      index === 0 &&
                        stgMode === '1' &&
                        dspFlg === 1 &&
                        item.valueStgHghtValid
                    "
                  >
                    <v-icon
                      v-if="tmStageList.curt.category.stg10mChg > 0"
                      small
                      class="state icon-arrow-up"
                      >arrow_upward</v-icon
                    >
                    <v-icon
                      v-else-if="tmStageList.curt.category.stg10mChg === 0"
                      small
                      class="state icon-arrow-down"
                      >arrow_forward</v-icon
                    >
                    <v-icon
                      v-else-if="tmStageList.curt.category.stg10mChg < 0"
                      small
                      class="state icon-arrow-down"
                      >arrow_downward</v-icon
                    >
                    <v-icon
                      v-if="tmStageList.curt.category.isAbnrml"
                      small
                      class="icon-qmflg"
                      >warning</v-icon
                    >
                  </span>
                  <span v-else-if="index === 0 && item.valueValid">
                    <v-icon
                      v-if="tmStageList.curt.category.stg10mChg > 0"
                      small
                      class="state icon-arrow-up"
                      >arrow_upward</v-icon
                    >
                    <v-icon
                      v-else-if="tmStageList.curt.category.stg10mChg === 0"
                      small
                      class="state icon-arrow-down"
                      >arrow_forward</v-icon
                    >
                    <v-icon
                      v-else-if="tmStageList.curt.category.stg10mChg < 0"
                      small
                      class="state icon-arrow-down"
                      >arrow_downward</v-icon
                    >
                    <v-icon
                      v-if="tmStageList.curt.category.isAbnrml"
                      small
                      class="icon-qmflg"
                      >warning</v-icon
                    >
                  </span>
                  <span
                    v-if="index === 0"
                    class="tm-pc-detail-info-curt-title tm-pc-stg-fld-color"
                    :stg-fld-color="fldColor"
                    :label-height="labelHeight"
                    v-show="showStgOvlvlNm(stgOvlvlNm)"
                  >
                    {{ stgOvlvlNm }}
                  </span>
                  &nbsp;
                </span>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense>
            <!-- 観測所情報 -->
            <v-list-item
              v-for="(item, index) in tmStageList.obsInfo"
              :key="`obs-${index}`"
              class="tm-pc-detail-info-list-item"
            >
              <v-row no-gutters>
                <v-col class="tm-pc-detail-info-list-title">{{
                  item.title
                }}</v-col>
                <v-col class="tm-pc-detail-info-list-value">
                  <div
                    v-if="checkItmkndCd(item.itmkndCd)"
                    class="tm-pc-link"
                    @click="openObs(item.ofcCd, item.itmkndCd, item.obsCd)"
                  >
                    {{ item.value }}
                  </div>
                  <div v-else-if="showQwtrDbBtn(item.qwtrObsCd, item.dbLink)">
                    <span
                      class="tm-pc-link"
                      @click="openQwtrDb(item.qwtrObsCd)"
                      >{{ item.obsValue }}</span
                    >
                    <!-- <span
                      class="tm-pc-link ml-1"
                      @click="openStgRank(item.qwtrObsCd)"
                      >{{ item.rankValue }}</span
                    > -->
                  </div>
                  <div v-else>
                    <span style="line-break: strict">{{ item.value }}</span>
                    <span
                      class="tm-pc-detail-info-curt-unit"
                      v-html="item.unit"
                    ></span>
                  </div>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>

          <!-- 基準値 -->
          <div class="tm-pc-detail-info-latest-value">
            {{ text.standard_title }}
          </div>
          <div class="tm-pc-detail-border-line">
            <span
              v-for="(item, index) in standardValue"
              :key="`sd-${index}`"
              v-show="showStandardValue(item)"
            >
              <span class="tm-pc-detail-info-curt-title"
                >{{ item.title }}:</span
              >
              <span
                class="tm-pc-detail-info-curt-value"
                v-if="stgMode === '1' && dspFlg === 2"
                >{{ item.value[0] }}</span
              >
              <span v-else class="tm-pc-detail-info-curt-value">{{
                item.value[stgMode]
              }}</span>
              <span
                class="tm-pc-detail-info-curt-unit"
                v-html="item.unit"
              ></span>
              &nbsp;
            </span>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
import Util from "../../../lib/util";
import mixin from "./../../../lib/mixin.js";

/**
 * 川の防災情報 [PC]水位 (詳細)観測所情報カード
 * TmStageDetailInfo.vue
 * @author ILUKE
 */

export default {
  name: "tm-stage-detail-info",
  mixins: [mixin],
  data() {
    return {
      text: {
        obsInfo: "観測所情報",
        obsType: "水位観測",
        obs_title: "■最新観測値",
        standard_title: "■基準値",
        rsys: "水系",
        rsysKana: "すいけい",
        checkMap: "地図で確認",
      },
      fldColor: "normal",
      labelHeight: "other",
      stgOvlvlNm: "",
    };
  },
  computed: {
    /**
     * 表示時刻
     */
    appTime: {
      get() {
        return Util.formatDate(this.$store.state.app.appTime);
      },
    },
    // 通常水位取得
    tmStageList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /**
     * 基準値 取得
     */
    standardValue: {
      get() {
        return this.$store.state.Telemeter.selectedTm.standardValue;
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /** 表示フラグ */
    dspFlg: {
      get() {
        return this.$store.state.Telemeter.selectedTm.tmStgDetailInfo.dspFlg;
      },
    },
    /** 水防団モード*/
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
    /**
     * 水位表示メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
  },
  mounted() {
    /** 水位超過 着色 */
    const crntfld = this.tmStageList.curt.category;
    this.fldColor = this.setFloodColor(crntfld.stgOvlvl);
    this.labelHeight = this.setLablHeight(crntfld.stgOvlvl);
    this.stgOvlvlNm = this.getStgOvlvlNm(crntfld.stgOvlvl);
  },
  methods: {
    // 観測所リンク
    openObs(ofcCd, itmkndCd, obsCd) {
      if (!this.$store.state.app.isCurrent) {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            ofcCd: ofcCd,
            itmkndCd: itmkndCd,
            obsCd: obsCd,
            appTime: Util.formatDate(
              this.$store.state.app.appTime,
              "YYYY-MM-DD HH:mm"
            ),
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_self", "noreferrer,noopener");
      } else {
        let routeData = this.$router.resolve({
          name: "tm",
          query: {
            ofcCd: ofcCd,
            itmkndCd: itmkndCd,
            obsCd: obsCd,
            isCurrent: this.$store.state.app.isCurrent,
            fld: this.$store.state.app.fldCtlParty,
          },
        });
        window.open(routeData.href, "_self", "noreferrer,noopener");
      }
    },
    showQwtrDbBtn(qwtrObsCd, dbLink) {
      if (qwtrObsCd !== null && qwtrObsCd !== undefined && dbLink === 1) {
        return true;
      } else {
        return false;
      }
    },
    openQwtrDb(qwtrObsCd) {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbLink + qwtrObsCd;
      window.open(link);
    },
    openStgRank(qwtrObsCd) {
      let link =
        this.$store.state.app.config.appConfig.linkUrls.qwtrDbstgRkLink +
        qwtrObsCd;
      window.open(link);
    },
    /**
     * 更新クリックイベント
     */
    renew() {
      this.$log.debug("[TmObs] renew()");
      this.$store.commit("app/renewTime");

      // URLクエリ更新
      let setQuery = Object.assign({}, this.$route.query);
      setQuery["isCurrent"] = true;
      delete setQuery["appTime"];
      delete setQuery["tmtime"];
      this.$router.replace({
        path: this.$route.path,
        query: setQuery,
      });
    },
    showStandardValue(item) {
      if ((!this.isFldCtl && item.title === "水防団待機水位") || (item.value[0] === "-- " && item.title === "氾濫開始水位")) {
        return false;
      }
      return true;
    },
    showStgOvlvlNm(title) {
      if (!this.isFldCtl && title === "水防団待機水位超過") {
        return false;
      }
      return true;
    },
    /** 水位超過 着色 */
    setFloodColor(ovlvl) {
      if (ovlvl === 90) {
        // 氾濫開始水位超過(危機管理)
        return "occurrence";
      } else if (ovlvl === 80) {
        // 氾濫危険水位超過
        return "danger";
      } else if (ovlvl === 60) {
        // 危険水位超過(危機管理)
        return "refuge";
      } else if (ovlvl === 30) {
        // 観測開始水位超過(危機管理)
        return "caution";
      } else if (ovlvl === 10) {
        // 水防団待機水位超過
        return "standbyed";
      } else {
        // 平常
        return "normal";
      }
    },
    setLablHeight(stgOvlvl) {
      if (10 <= stgOvlvl && stgOvlvl <= 90) {
        return "stgOvlvl";
      }
      return "other";
    },
    getStgOvlvlNm(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "氾濫開始水位超過";
      } else if (stgOvlvl === 80) {
        return "氾濫危険水位超過";
      } else if (stgOvlvl === 60) {
        return "避難判断水位超過";
      } else if (stgOvlvl === 30) {
        return "氾濫注意水位超過";
      } else if (stgOvlvl === 10) {
        return "水防団待機水位超過";
      }
      return "";
    },
    checkItmkndCd (kndCd) {
      if (kndCd) {
        if (kndCd === 2) {
          return false;
        } else if (kndCd === 20) {
          return false;
        } else if (kndCd === 21) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    },
    /** 同タブ内でマップ画面に遷移 */
    openMap() {
      let path = "/pc/tm";
      if (this.$store.state.map.zoom !== undefined) {
        this.routerPushTm(path);
      } else {
        this.routerOpenTm(path);
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
